import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk /**the middleware */ from 'redux-thunk'; //for async
import rootReducer /**the reducer that combine all the reducer */ from './reducers';

const middleware = [thunk];

// Creates store that contain many sub-states.
const store = createStore(
  rootReducer,
  {},
  composeWithDevTools(applyMiddleware(...middleware)),
);

export default store;
